<div class="create-account">
  <p
    class="create-account__content">
    {{'LOGIN_PAGE.NOT_REGISTER' | translate}}
  </p>
  <a
    routerLink="/register"
    class="create-account__link">
    {{'LOGIN_PAGE.CREATE_ACCOUNT' | translate}}
  </a>
</div>
